//** District Api

import { createAsyncThunk } from '@reduxjs/toolkit';
// Axios Imports
import axios from '@src/service/axios';
import { toast } from 'react-toastify';
export const getDistrict = createAsyncThunk('locationSliceData/getDistrict', async () => {
    try {
        let response = await axios.get('/District', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteDistrict = createAsyncThunk('locationSliceData/deleteDistrict', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/District/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'District deleted successfully.');
        await dispatch(getDistrict());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createDistrict = createAsyncThunk('locationSliceData/createDistrict', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/District', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'District added succesfully.');
        await dispatch(getDistrict());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateDistrict = createAsyncThunk('locationSliceData/updateDistrict', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/District/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'District updated succesfully.');
        await dispatch(getDistrict());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateDistrictStatus = createAsyncThunk('locationSliceData/updateDistrictStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/District/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || ' Status updated successfully !');
        await dispatch(getDistrict());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
